import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { desktopCourseNumberTitleStyle, desktopCourseTextTitleStyle, selectedCourseMainContainerStyle, courseNumberAndTextSelectedStyle } from './styles/desktop';

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
});

class Accordion extends React.Component {
    state = {
        expanded: null,
        currentExpanded: null
    };

    handleChange = (panel, elemId) => (event, expanded) => {

        if (this.state.currentExpanded != null) {
            this.state.currentExpanded.classList.remove('zoomIn');
        }



        if (document.getElementById(elemId).parentElement.classList.contains('zoomOut')) {
            document.getElementById(elemId).parentElement.classList.remove('zoomOut');
        }

        document.getElementById(elemId).parentElement.classList.add('animated');
        document.getElementById(elemId).parentElement.classList.add('zoomIn');


        this.setState({
            expanded: expanded ? panel : false,
            currentExpanded: document.getElementById(elemId).parentElement
        });
    };

    generateCourses() {
        const { classes } = this.props;
        const { expanded } = this.state;
        let _this = this;
        return (
            <div>
                {
                    this.props.courses.map(function (course) {
                        return (
                            <div id={course.subtitle + '-container-div'} key={course.subtitle + '-container-div'} className='animated'>
                                <ExpansionPanel style={expanded === course.subtitle ? selectedCourseMainContainerStyle : {}} id={course.subtitle + 'expansion-panel'} key={course.subtitle + 'expansion-panel'} expanded={expanded === course.subtitle} onChange={_this.handleChange(course.subtitle, course.subtitle + 'expansion-panel')}>
                                    <ExpansionPanelSummary key={course.subtitle + 'expansion-summary-panel'} expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading} style={expanded === course.subtitle ? courseNumberAndTextSelectedStyle : desktopCourseNumberTitleStyle} >{course.subtitle}</Typography>
                                        <Typography className={classes.secondaryHeading} style={expanded === course.subtitle ? courseNumberAndTextSelectedStyle : desktopCourseTextTitleStyle}>
                                            {course.title}
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails key={course.subtitle + 'expansion-panel-details'}>
                                        <Typography style={{color: '#dedede'}}>
                                            {course.description}
                                        </Typography>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                             </div>
                        )


                    })
                }
            </div>
        )
    }
    render() {
        const { classes } = this.props;
        const { expanded } = this.state;

        return (
            <div className={classes.root}>
                {this.generateCourses()}
            </div>
        );
    }
}

Accordion.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Accordion);



// WEBPACK FOOTER //
// ./src/components/course/Accordion.js